import {
  DASHBOARD_SET_CURRENT,
  DASHBOARD_SET_LAYOUT,
  DASHBOARD_START_EDIT,
  DASHBOARD_DISCARD_EDIT,
  DASHBOARD_SAVE_EDIT,
  DASHBOARD_SET_NAME,
  DASHBOARD_SET_DATA_LOADED,
  DASHBOARD_START_DATA_LOADING,
  DASHBOARD_START_CARD_DATA_LOADING,
  DASHBOARD_SET_CARD_DATA_LOADED,
  DASHBOARD_PRESENT_TOGGLE,
  DASHBOARD_RESET_STATE,
  DASHBOARD_SET_CARD_DATA_ERROR,
  DASHBOARD_EDIT_LOADING,
  SET_STAR_FOR_DASHBOARD_SELECTED,
  DASHBOARD_REMOVE_CARD,
} from '../actions/constants';

const getDefaultState = () => ({
  currentId: null,
  name: null,
  cards: [],
  isEditing: false,
  isLoading: false,
  isPresenting: false,
  isEditLoading: false,
  cardDataBySliceId: [],
  tempStateData: {
    cards: [],
    name: null,
  },
});

const updateSliceData = (state, sliceId, data) => {
  const newCardData = state.cardDataBySliceId[sliceId];
  return {
    ...state,
    cardDataBySliceId: {
      ...state.cardDataBySliceId,
      [sliceId]: {
        ...state.cardDataBySliceId[sliceId],
        ...data,
      },
    },
  };
};

const defaultState = getDefaultState();

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case DASHBOARD_SET_LAYOUT: {
      const layout = action.data;
      const newCards = state.cards.map((card, idx) => ({
        ...card,
        layout: layout[idx],
      }));
      return {
        ...state,
        cards: newCards,
      };
    }

    case DASHBOARD_SET_NAME: {
      return {
        ...state,
        name: action.data,
      };
    }

    case DASHBOARD_START_EDIT: {
      // Set temp data, which can be used when user discards the changes
      const tempStateData = {
        cards: state.cards,
        name: state.name,
      };
      return {
        ...state,
        tempStateData,
        isEditing: true,
      };
    }

    case DASHBOARD_DISCARD_EDIT: {
      // Merge temp data into state, so that changes done during editing are discarded
      return {
        ...state,
        ...state.tempStateData,
        isEditing: false,
        isEditLoading: false,
      };
    }

    case DASHBOARD_SAVE_EDIT: {
      return {
        ...state,
        isEditing: false,
        isEditLoading: false,
      };
    }

    case DASHBOARD_EDIT_LOADING: {
      return {
        ...state,
        isEditLoading: true,
      };
    }

    case DASHBOARD_SET_DATA_LOADED: {
      const data = action.data;
      return {
        ...state,
        ...data,
        isLoading: false,
      };
    }

    case DASHBOARD_START_DATA_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case DASHBOARD_START_CARD_DATA_LOADING: {
      return updateSliceData(state, action.sliceId, {
        isLoading: true,
      });
    }

    case DASHBOARD_SET_CARD_DATA_LOADED: {
      const dataToSet = { ...action.data, isLoading: false, error: null };
      return updateSliceData(state, action.sliceId, dataToSet);
    }

    case DASHBOARD_SET_CARD_DATA_ERROR: {
      const dataToSet = { isLoading: false, error: action.error };
      return updateSliceData(state, action.sliceId, dataToSet);
    }

    case DASHBOARD_PRESENT_TOGGLE: {
      return {
        ...state,
        isPresenting: !state.isPresenting,
      };
    }
    case DASHBOARD_RESET_STATE: {
      return getDefaultState();
    }
    case SET_STAR_FOR_DASHBOARD_SELECTED: {
      if (String(action.dashboardId) === String(state.id)) {
        return {
          ...state,
          isStarred: action.starStatus,
        };
      }
      return state;
    }

    case DASHBOARD_REMOVE_CARD: {
      const newCardList = state.cards.filter(elem => elem.id !== action.id);
      return {
        ...state,
        cards: newCardList,
      };
    }

    default: return state;
  }
}
